import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { MingaPermission } from 'libs/domain';
import { poll_ng_grpc_pb } from 'libs/generated-grpc-web';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { IEmptyStateIcon } from '@app/src/app/components/EmptyState';
import { GroupsFacadeService } from '@app/src/app/groups/services';
import { ContentEvents } from '@app/src/app/minimal/services/ContentEvents';
import { PollAnswerStateService } from '@app/src/app/minimal/services/PollAnswerState';
import { StreamManager } from '@app/src/app/minimal/services/StreamManager';
import { PermissionsService } from '@app/src/app/permissions';
import { ContentState } from '@app/src/app/services/ContentState';

@Component({
  selector: 'mg-home-polls',
  templateUrl: './home-polls.component.html',
  styleUrls: ['./home-polls.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePollsComponent implements OnDestroy {
  // Clean up
  private readonly _destroyedSubject = new ReplaySubject<void>(1);

  emptyStateIcons: IEmptyStateIcon[] = [];
  canCreatePolls = false;

  /** Component constructor */
  constructor(
    public pollAnswerService: PollAnswerStateService,
    public _contentEvents: ContentEvents,
    public groupsFacade: GroupsFacadeService,
    public contentState: ContentState,
    public pollService: poll_ng_grpc_pb.Poll,
    private _permissions: PermissionsService,
    private _streamManager: StreamManager,
  ) {
    // load groups for group feed content
    groupsFacade.dispatchLoadAll();

    this.emptyStateIcons = [
      {
        icon: 'post',
        text: 'Add',
      },
      {
        icon: 'polls-o',
        text: 'Poll',
      },
    ];

    this.canCreatePolls = this._permissions.hasPermission(MingaPermission.CONTENT_POLL_CREATE);

    this._contentEvents.onContentDeleted.pipe(takeUntil(this._destroyedSubject)).subscribe(() => {
      this._streamManager.restartStream('AdminPolls');
    });
    this._contentEvents.onContentFeedsUpdate.pipe(takeUntil(this._destroyedSubject)).subscribe(() => {
      this._streamManager.restartStream('AdminPolls');
    });
  }

  ngOnDestroy(): void {
    this._destroyedSubject.next();
    this._destroyedSubject.complete();
  }

  onItemClick(e) {
    const contentContextHash = e.model.item.id;
    if (contentContextHash) {
      this._contentEvents.emitContentOpen({ contentContextHash });
    }
  }
}
